var AboutUsComponent = /** @class */ (function () {
    function AboutUsComponent() {
    }
    AboutUsComponent.prototype.ngOnInit = function () {
    };
    return AboutUsComponent;
}());
export { AboutUsComponent };



// WEBPACK FOOTER //
// ./src/app/about-us/about-us.component.ts.pre-build-optimizer.js